module.exports = __webpack_public_path__ + "img/icon_budget_hover.8363f3ff.png";